import { createClient } from '@supabase/supabase-js'

// These will be environment variables - we'll set them up next
const supabaseUrl = process.env.REACT_APP_SUPABASE_URL
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY

// Only create client if environment variables are available
export const supabase = (supabaseUrl && supabaseAnonKey) 
  ? createClient(supabaseUrl, supabaseAnonKey)
  : null

// Helper function to check if Supabase is configured
export const isSupabaseConfigured = () => {
  return Boolean(supabaseUrl && supabaseAnonKey && supabase)
}

// Database table names
export const TABLES = {
  HOTEL_SETTINGS: 'hotel_settings',
  MENU_SECTIONS: 'menu_sections', 
  MENU_ITEMS: 'menu_items',
  OPENING_HOURS: 'opening_hours',
  EVENTS: 'events',
  CONTACT_INFO: 'contact_info'
}